import axios, {
  ResponseData
} from './base.ts'
import {
  AxiosPromise
} from 'axios'
const url = ``

export function getList(data = {}) {
  return axios.request({
    url: `${url}/users`,
    method: "get",
    params: data,
  })
}

export function getListSelect(data = {}) {
  return axios.request({
    url: `${url}/users/select`,
    method: "get",
    params: data,
  })
}
export function getDataById(id,params={}){
  return axios.request({
    url: `${url}/user/${id}`,
    method: "get",
    params,
  })
}

export function deleteData(id,data) {
  return axios.request({
    url: `${url}/user/${id}`,
    method: "delete",
    params:data,
  })
}
export function editData(id, data) {
  return axios.request({
    url: `${url}/user/${id}`,
    method: "put",
    data: data,
  })
}
export function getOpinionList(data = {}) {
  return axios.request({
    url: `${url}/opinions`,
    method: "get",
    params: data,
  })
}